/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * CALCLISTへの追加リクエスト
 * @export
 * @interface AddCalcListRequest
 */
export interface AddCalcListRequest {
    /**
     * ファイル名
     * @type {string}
     * @memberof AddCalcListRequest
     */
    fileName: string;
    /**
     * タイトル
     * @type {string}
     * @memberof AddCalcListRequest
     */
    title: string;
    /**
     * 説明
     * @type {string}
     * @memberof AddCalcListRequest
     */
    description: string;
    /**
     * 対象時刻
     * @type {string}
     * @memberof AddCalcListRequest
     */
    tgttime?: string;
}

/**
 * Check if a given object implements the AddCalcListRequest interface.
 */
export function instanceOfAddCalcListRequest(value: object): value is AddCalcListRequest {
    if (!('fileName' in value) || value['fileName'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    return true;
}

export function AddCalcListRequestFromJSON(json: any): AddCalcListRequest {
    return AddCalcListRequestFromJSONTyped(json, false);
}

export function AddCalcListRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AddCalcListRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'fileName': json['fileName'],
        'title': json['title'],
        'description': json['description'],
        'tgttime': json['tgttime'] == null ? undefined : json['tgttime'],
    };
}

export function AddCalcListRequestToJSON(json: any): AddCalcListRequest {
    return AddCalcListRequestToJSONTyped(json, false);
}

export function AddCalcListRequestToJSONTyped(value?: AddCalcListRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'fileName': value['fileName'],
        'title': value['title'],
        'description': value['description'],
        'tgttime': value['tgttime'],
    };
}

